import SiteRoute from 'routes/';

function App() {
  return SiteRoute;
}

export default App;
